{
  "version": "1.2.6",
  "objects": {
    "7431911414815001262": {
      "type": "frame",
      "id": "7431911414815001262",
      "z": 7196,
      "textContent": "",
      "left": 2777.225779111606,
      "top": 1129.8673314462874,
      "width": 400,
      "height": 500,
      "scaleX": 1.4681114169199032,
      "scaleY": 1.0383125,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7431911414818342093": {
      "type": "wireframe",
      "id": "7431911414818342093",
      "z": 6346,
      "top": 1219.7267064462874,
      "left": 2807.225779111606,
      "width": 524.9778526372893,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Phone number",
        "iconLeft": { "prefix": "fas", "iconName": "phone-flip" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414813839942": {
      "type": "wireframe",
      "id": "7431911414813839942",
      "z": 6347,
      "top": 1279.7267064462874,
      "left": 2807.225779111606,
      "width": 525.1032810482238,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a1",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Email",
        "iconLeft": { "prefix": "fas", "iconName": "envelope" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414827040992": {
      "type": "wireframe",
      "id": "7431911414827040992",
      "z": 6348,
      "top": 1339.7267064462874,
      "left": 2807.225779111606,
      "width": 524.8532810482238,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a2t",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Address line 1",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414819503661": {
      "type": "wireframe",
      "id": "7431911414819503661",
      "z": 6349,
      "top": 1399.5860814462874,
      "left": 2807.225779111606,
      "width": 525.1032810482238,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a3",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Address line 2",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414822163328": {
      "type": "wireframe",
      "id": "7431911414822163328",
      "z": 6350,
      "top": 1459.4454564462874,
      "left": 2807.225779111606,
      "width": 525.1032810482238,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a4",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "City",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414815706838": {
      "type": "frame",
      "id": "7431911414815706838",
      "z": 7076,
      "textContent": "Frame 194",
      "left": 2807.225779111606,
      "top": 1159.8673314462874,
      "width": 400,
      "height": 500,
      "scaleX": 1.318111416919903,
      "scaleY": 0.07971875,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414815001262",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7431911414821858046": {
      "type": "wireframe",
      "id": "7431911414821858046",
      "z": 7079,
      "top": 1159.8673314462874,
      "left": 2807.225779111606,
      "width": 253.53190456471566,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815706838",
      "layoutPosition": null,
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "First name",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414822401063": {
      "type": "wireframe",
      "id": "7431911414822401063",
      "z": 7082,
      "top": 1159.8673314462874,
      "left": 3076.20108365679,
      "width": 256.2692622227769,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815706838",
      "layoutPosition": "a0l",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Last name",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414813375946": {
      "type": "frame",
      "id": "7431911414813375946",
      "z": 7096,
      "textContent": "Frame 194",
      "left": 2807.225779111606,
      "top": 1519.3048314462874,
      "width": 400,
      "height": 500,
      "scaleX": 1.318111416919903,
      "scaleY": 0.07971875,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414815001262",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a5",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7431911414818941937": {
      "type": "wireframe",
      "id": "7431911414818941937",
      "z": 7079,
      "top": 1519.3048314462874,
      "left": 2807.225779111606,
      "width": 253.53190456471566,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414813375946",
      "layoutPosition": null,
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "State/Province",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414822950175": {
      "type": "wireframe",
      "id": "7431911414822950175",
      "z": 7082,
      "top": 1519.3048314462874,
      "left": 3076.20108365679,
      "width": 256.2692622227769,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414813375946",
      "layoutPosition": "a0l",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Zip code",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414817508903": {
      "type": "wireframe",
      "id": "7431911414817508903",
      "z": 7106,
      "top": 1579.1642064462874,
      "left": 2807.225779111606,
      "width": 525.1032810482238,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414815001262",
      "layoutPosition": "a6",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Country",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    }
  }
}
